import React from 'react'

import { ChromePicker } from 'react-color';

const SIZE = 50
export default class ColorPicker extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      title: props.title,
      color: props.color,
      displayColorPicker: false
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _renderSwatches(){
    let {
      color
    } = this.state

    return this.props.COLORS.map(value => {

      let style = {
        height: SIZE,
        width: SIZE,
        backgroundColor: value,
      }

      if(value === 'transparent'){
        style = {
            ...style,
            ...styles.transparent
        }
      }

      let isSelected = color == value

      if(isSelected){
        style.border = 'dashed'
      }

      return (
          <a
            className="color"
            onClick={() => {
              this.setState({ color: value })
              this.props.onColorSelected(value)
            }}
          >
            <div
              className={ isSelected ? 'selected flaticon2-check-mark' : '' }
              style={{
                cursor: 'pointer',
                position: 'relative',
                outline: 'none',
                float: 'left',
                borderRadius: 4,
                marginRight: 6,
                marginBotton: 6,
                border: '1px solid #d3d3d3',
                ...style,
                borderColor: isSelected ? "#cccccc" : "#e5e5e5",
                borderWidth: 3,
              }}
            />
          </a>
      )
    })
  }

  _renderColorInput(){
    let {
      title,
      color
    } = this.state

    let displayColor = color
    if(displayColor){
       displayColor = displayColor.replace("#", "")
    }

    if(displayColor == "transparent"){
      displayColor = "clear"
    }

    return (
      <div
        className={ `color-box-value ${this.props.colorBoxClassName}`}
        style={{
          height: SIZE,
          minWidth: SIZE,
          cursor: 'pointer',
          position: 'relative',
          outline: 'none',
          display: 'inline-block',
          borderRadius: 4,
          marginRight: 0,
          marginLeft: 0,
          marginBotton: 6,
          boxShadow: 'rgb(240, 240, 240) 0px 0px 0px 1px inset',
          boxSizing: 'content-box',
          backgroundColor: 'white',
          ...this.props.colorBoxStyle
        }}
      >
        <a
          onClick={() => {
            this.setState({ displayColorPicker: true })
          }}
        >
          <div
            style={{
              ...styles.hash,
              color: this.state.color
            }}
          >
            #
          </div>
          <div
            style={{
              ...styles.colorText,
              ...this.props.colorTextStyle
            }}
          >
            { displayColor }
          </div>
        </a>

        { this._renderColorPickerModal()}
      </div>
    )
  }

  _renderColorPickerModal(){
    let {
      color,
      displayColorPicker
    } = this.state

    if(!displayColorPicker){
      return null
    }

    return (
      <div style={ styles.popover }>
        <div style={ styles.cover }
          onClick={() => {
             this.setState({ displayColorPicker: false })
          } }
        />
        <ChromePicker
          color={color || "#FFF"}
          onChange={color => {
            let hex = color.hex
            if(color.rgb.a !== 1){
              hex = `${color.hex}${decimalToHex(color.rgb.a)}`
            }
            this.setState({ color: hex })
            this.props.onColorSelected(hex)
          }}
        />
      </div>
    )
  }

  render(){
    let {
      title,
    } = this.state

    return (
      <div className="color-picker" style={{ marginBottom: 30 }}>

        { title && 
          <div className="align-items-center" style={{ marginBottom: 0 }}>
            { title }
          </div>
        }

        { this._renderSwatches() }

        { this._renderColorInput() }
        <div style={{clear: "both"}}></div>
      </div>
    )
  }
}

const styles = {
  colorText: {
    height: SIZE,
    minWidth: SIZE * 2.4,
    float: 'left',
    verticalAlign: 'middle',
    lineHeight: SIZE+"px",
    fontSize: 16,
    fontWeight: 400,
    textTransform: 'uppercase',
    paddingLeft: 15,
    paddingRight: 15
  },
  colorTextStyle: {},
  hash: {
    height: SIZE,
    minWidth: SIZE,
    float: 'left',
    textAlign: 'center',
    verticalAlign: 'middle',
    lineHeight: SIZE+"px",
    fontSize: 16,
    fontWeight: 400,
    background: 'rgb(230, 230, 230)',
    color: 'rgb(152, 161, 164)',
    borderBottomLeftRadius: 4,
    borderTopLeftRadius: 4,
  },
  cover: {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  },
  popover: {
    position: 'absolute',
    zIndex: '2',
    top: -100,
    left: -225
  },
  transparent: {
    backgroundImage: 'linear-gradient(45deg, #e5e5e5 25%, transparent 25%), linear-gradient(135deg, #e5e5e5 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e5e5e5 75%), linear-gradient(135deg, transparent 75%, #e5e5e5 75%)',
    backgroundSize: '10px 10px',
    backgroundPosition: '0 0, 5px 0, 5px -5px, 0px 5px',
    backgroundColor: '#f5f5f5'
  }
}

const decimalToHex = (alpha: number) => alpha === 0 ? '00' : Math.round(255 * alpha).toString(16)

ColorPicker.defaultProps = {
  colorBoxClassName: "",
  colorBoxStyle: {},
  COLORS : ['#6aa84f', '#3d85c6', '#e69138', '#fa6160', '#333333',]
}
